import { SchedulerStatusResponse } from "../../../../services";

export const describeStatus = ({
  status,
  lastOutcome,
  lastFailureErrorName,
}: SchedulerStatusResponse): string | null => {
  const notes: string[] = [];

  if (lastOutcome === "FAILURE") {
    notes.push(
      lastFailureErrorName
        ? `The last run failed with ${lastFailureErrorName}.`
        : "The last run failed.",
    );
  }
  if (status === "critical") {
    notes.push("No successful run for over two expected intervals.");
  }
  if (status === "warning" && lastOutcome !== "FAILURE") {
    notes.push("No successful run for over one expected interval.");
  }
  if (status === "unknown") {
    notes.push("No run has been recorded yet.");
  }

  return notes.length > 0 ? notes.join(" ") : null;
};
